import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    
    useEffect(() => {
        const mainElement  =  document.getElementById('main');
        if(mainElement){
            mainElement.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
    }, [pathname]);

    return null; // No UI is rendered
};

export default ScrollToTop;
